<script>
export default {
  props: {
    headerTitle: {
      type: String,
      default: '',
    },
    headerContent: {
      type: String,
      default: '',
    },
    headerContentValue: {
      type: String,
      default: '',
    },
    headerImage: {
      type: String,
      default: '',
    },
  },
};
</script>

<!-- eslint-disable vue/no-unused-refs -->
<!-- Added ref for writing specs -->
<template>
  <div class="flex flex-col items-start px-10 pt-10 pb-0">
    <img v-if="headerImage" :src="headerImage" alt="No image" class="mb-4" />
    <h2
      data-test-id="modal-header-title"
      class="text-2xl font-bold tracking-tight text-foreground leading-none"
    >
      {{ headerTitle }}
    </h2>
    <p
      v-if="headerContent"
      data-test-id="modal-header-content"
      class="w-full mt-3 text-sm leading-relaxed break-words text-muted-foreground font-medium"
    >
      {{ headerContent }}
      <span v-if="headerContentValue" class="text-sm font-bold text-foreground">
        {{ headerContentValue }}
      </span>
    </p>
    <slot />
  </div>
</template>
